import * as React from "react";
import { useNavigate } from "react-router-dom";
import LinkGuideIcon from "../../icons/LinkGidIcon";
import style from "./LinkGuide.module.scss";
import { ROUTES } from "../../../constants/routes";

interface LinkGuideProps {
  variant?: "header";
}

export default function LinkGuide({ variant }: LinkGuideProps) {
  const navigate = useNavigate();

  return (
    <div
      className={`${style.linkGuide} ${variant === "header" ? style.linkGuideHeader : ""}`}
      onClick={() => navigate(ROUTES.GID)}
    >
      <LinkGuideIcon />
    </div>
  );
}
